import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";

const plans = [
  {
    title: "One Call For All",
    description: "Calling multiple people to get your septic fixed stinks.",
    features: [
      "One dedicated contact",
      "Priority scheduling",
      "Expert local team",
      "Comprehensive solutions",
    ],
    icon: "📞",
  },
  {
    title: "Proactive Home Team",
    description: "Avoid future septic system problems with proactive services.",
    features: [
      "Regular maintenance",
      "Preventive inspections",
      "System monitoring",
      "Priority repairs",
    ],
    icon: "🛡️",
    highlighted: true,
  },
  {
    title: "Win Now And Later",
    description: "Our EZ Maintenance Plans give you peace of mind for years to come.",
    features: [
      "Predictable pricing",
      "Long-term coverage",
      "Emergency support",
      "System protection",
    ],
    icon: "🏆",
  },
];

export default function AdvantagesPlans() {
  return (
    <section id="advantage-plans" className="py-20 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent-text font-semibold uppercase tracking-wide mb-2">
            Maintenance Plan
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Get The EZ Maintenance Plans For Your Septic Needs
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto">
            Every region plays by its own rules. We tailor all of our plans to your local regulations, making personalized care for your septic system easy.
          </p>
        </div>

        {/* Plans Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {plans.map((plan, index) => (
            <Card
              key={index}
              className={`relative transition-all ${
                plan.highlighted
                  ? "border-accent shadow-lg scale-105 md:scale-110"
                  : "hover:shadow-md"
              }`}
            >
              {plan.highlighted && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-accent text-accent-foreground px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </div>
              )}

              <CardHeader>
                <div className="text-4xl mb-4">{plan.icon}</div>
                <CardTitle className="text-2xl">{plan.title}</CardTitle>
                <CardDescription className="text-base">{plan.description}</CardDescription>
              </CardHeader>

              <CardContent className="space-y-6">
                <ul className="space-y-3">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3">
                      <Check className="w-5 h-5 text-accent flex-shrink-0" />
                      <span className="text-foreground">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  className={`w-full ${
                    plan.highlighted
                      ? "bg-accent hover:bg-accent/90 text-accent-foreground"
                      : "border-primary text-primary hover:bg-primary/5"
                  }`}
                  variant={plan.highlighted ? "default" : "outline"}
                  onClick={() => {
                    window.location.href = '/maintenance-plans';
                  }}
                >
                  Learn More »
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 text-center">
          <h3 className="text-2xl font-bold text-foreground mb-4">
            Ready to Get Your EZ Maintenance Plan?
          </h3>
          <p className="text-foreground/70 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers who have peace of mind with our comprehensive maintenance plans.
          </p>
          <Button
            size="lg"
            className="bg-accent hover:bg-accent/90 text-accent-foreground"
            onClick={() => {
              window.location.href = '/maintenance-plans';
            }}
          >
            Find An EZ Maintenance Plan »
          </Button>
        </div>
      </div>
    </section>
  );
}
